import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { FuseTranslationLoaderService } from 'app/services/translation-loader.service';
import { locale as english } from './i18n/en';
import { locale as french } from './i18n/fr';
import { LegalEntityPracticeV3InvoicesState } from './legalEntityPracticeV3Invoices.state';
@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([LegalEntityPracticeV3InvoicesState])]
})
export class LegalEntityInvoiceStoreModule {
  constructor(translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(english, french);
  }
}
